import React from 'react';
import { connect } from 'react-redux';

import { CommonPagePromo } from 'components/no-auth/common/CommonPagePromo';
import { LightDiskButton } from 'components/no-auth/common/fromAuth/LightDiskButton/LightDiskButton';
import { LightHeaderPanel } from 'components/no-auth/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { LightIcon } from 'components/no-auth/common/fromAuth/LightIcon/LightIcon';
import { LightText } from 'components/no-auth/common/fromAuth/LightText/LightText';
import { MobileHelpLink } from 'components/no-auth/help/styles';
import ZendeskHelpMobileSearch from 'components/no-auth/help/ZendeskHelpMobileSearch';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'components/no-auth/utils';

import { toggleSpinner } from 'actions/appAction';
import { toggleChat } from 'actions/chatAction';

import { getLangCountryPrefix } from 'helpers/utils';

const ZendeskHelpMobileCategoryPage = (props) => {
    const category = props.category;
    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;
    const urlParams = useGetQueryParams();

    const filteredSections = props.sections?.filter((section) => {
        return section.category_id === category?.id && !section.directLink;
    });

    const sections = filteredSections.map((item) => {
        return (
            <MobileHelpLink key={item.id} href={getHelpCenterUrl(`${url}/category/${item.category_id}/section/${item.id}`, urlParams)}>
                <LightText useThemeColor>{item.name}</LightText>
                <LightIcon useThemeColor name="chevron-right" color={'purple'} leftIndent={'16px'} />
            </MobileHelpLink>
        );
    });

    return (
        <CommonPagePromo
            useThemeColor
            backUrl={category?.directLink ? null : getHelpCenterUrl(url, urlParams)}
            type={'tagA'}
            buttonId={'helpPageBackButton'}
            rightHeaderComponent={
                !urlParams.platform ? (
                    <LightDiskButton
                        type={'tagA'}
                        href={props.backUrl}
                        onClick={() => {
                            props.toggleSpinner(true);
                            sessionStorage?.removeItem('prevUrl');
                        }}
                        iconName={'cross'}
                        useThemeColor
                    />
                ) : null
            }
        >
            <LightHeaderPanel useThemeColor title={category?.name} />
            <ZendeskHelpMobileSearch isMobilePlatform={urlParams.platform === 'ios' || urlParams.platform === 'android'} />
            {sections}
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat, toggleSpinner })(NotAuthBasePage(ZendeskHelpMobileCategoryPage));
